import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { fetchUserResponses, fetchQuestionsAndOptions, decodeData, fetchOutcomesByAsssessmentAndUserId } from '../../api/AssessmentHelper';
import { ClipLoader } from "react-spinners";
import { capitalizeWords } from "../../utils/helpers";
import { getUserId, getAccesstoken } from '../../utils/auth';
import { generateAssessmentReport } from '../../utils/pdfGenerator';
import { Link } from 'react-router-dom';
import { Buffer } from "buffer";
import assessmentInterpretations from "../../utils/ScoreInterpretation";
import { getScoreInterpretation } from '../../utils/ScoreInterpretation';
import ProgressBar from "../Shared/ProgressBar";

const ViewResponses = () => {
    const [responses, setResponses] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [generatingPDF, setGeneratingPDF] = useState(false);
    const [assessmentOutcome, setAssessmentOutcome] = useState(null);

    const { assessmentId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const access_token = getAccesstoken();
    const user_id = getUserId();

    const searchParams = new URLSearchParams(location.search);
    const encodedData = searchParams.get("details");
    const { name: assessmentName } = decodeData(encodedData);

    const encodeData = (name) => {
        const obj = { name };
        return encodeURIComponent(Buffer.from(JSON.stringify(obj)).toString("base64"));
    };

    useEffect(() => {
        const fetchData = async () => {
            if (!assessmentId || !access_token) {
                setError('Please login to continue');
                return;
            }

            try {
                setLoading(true);
                setError(null);

                // Fetch assessment outcome
                const outcomeData = await fetchOutcomesByAsssessmentAndUserId(assessmentId, user_id, access_token);
                setAssessmentOutcome(outcomeData);

                // Fetch questions and responses
                const questionsData = await fetchQuestionsAndOptions(assessmentId, access_token);
                if (!questionsData || !questionsData.questions) {
                    throw new Error('Failed to fetch questions');
                }
                setQuestions(questionsData.questions);

                const userResponses = await fetchUserResponses(assessmentId, user_id, access_token);
                if (!userResponses) {
                    throw new Error('Failed to fetch responses');
                }
                setResponses(userResponses);

            } catch (error) {
                console.error('Error fetching data:', error);
                setError(error.message || 'Failed to load responses');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [assessmentId, access_token, user_id]);

    const handleBack = () => {
        navigate(-1); // Navigate back to the previous page
    };

    const handleDownloadPDF = async () => {
        try {
            const pdfDoc = await generateAssessmentReport(assessmentName, responses);
            pdfDoc.download(`${assessmentName}_assessment_report.pdf`);
        } catch (error) {
            console.error('Error downloading PDF:', error);
            setError('Failed to generate PDF report. Please try again.');
        }
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    // const { interpretation, out_of_score, adjustedScore } = getScoreInterpretation(
    //     assessmentName,
    //     assessmentOutcome?.total_score || 0,
    //     {
    //         waistCircumference: assessmentOutcome?.waistCircumference,
    //         wthRatio: assessmentOutcome?.wthRatio,
    //         bri: assessmentOutcome?.bri,
    //         gender: assessmentOutcome?.gender,
    //     }
    // );

    const { interpretationHeading, scoreMessageText, interpretationSummary, selectedInterpretation, out_of_score, adjustedScore } =
        getScoreInterpretation(assessmentName, assessmentOutcome.total_score || 0);

    return (
        <div className="view-responses-container">
            {/* Results Widget Section */}
            <div className="row mb-4">
                <div className="col-xl-12">
                <div className="font-md fw-semibold">Result for {assessmentName} Assessment</div>
                <div className="d-flex gap-2 justify-content-end mt-2 mb-2">
    <Link style={{ fontSize: "22px" }} onClick={handleBack}>
        <i className="fa-solid fa-left-long icon"></i> Back
    </Link>
    {/* <button
        onClick={handleDownloadPDF}
        style={{
            all: "unset",
            cursor: generatingPDF ? "not-allowed" : "pointer",
            fontSize: "22px",
            marginLeft: '10px',
            color: 'var(--theme-color)',
            opacity: generatingPDF ? 0.6 : 1,
        }}
        disabled={generatingPDF}
    >
        <i className="fa-solid fa-download icon"></i> Download
    </button> */}
</div>

                    <div className="assesment-cards">
                        {/* <div className="dashboard-title mb-3">
                            
                        </div>
                        <h3>Your Score: {adjustedScore} {out_of_score ? ` / ${out_of_score}` : ''}</h3>
                        <br />
                        <h3>Result: <span style={{ fontSize: '16px', marginTop: '10px', lineHeight: '20px', fontWeight: 'normal' }}><div dangerouslySetInnerHTML={{ __html: interpretation }} /></span></h3>
                        <br />
                        {assessmentInterpretations[assessmentName]?.progressBarSettings && (
                            <ProgressBar
                                score={adjustedScore}
                                thresholds={assessmentInterpretations[assessmentName].progressBarSettings.thresholds}
                                labels={assessmentInterpretations[assessmentName].progressBarSettings.labels}
                                colors={assessmentInterpretations[assessmentName].progressBarSettings.colors}
                            />
                        )}
                         */}
                         <div className="results-container">
                <h2 style={{marginBottom: '15px'}}>{interpretationHeading}</h2>
                
                {/* <ul>
 
// {interpretationSummary.map((summary, index) => {
//   const [boldText, normalText] = summary.split(":");
  
//   return (
//     <p key={index} style={{ fontSize: "16px", marginBottom: "5px" }}>
//       <strong>{boldText}:</strong></p>
//       <p> {normalText}
//     </p>
//   );
// })}

  {interpretationSummary.map((summary, index) => {
  const [boldText, normalText] = summary.split(":");
  
  return (
    <li key={index} style={{ fontSize: "16px", marginBottom: "5px" }}>
      <strong>{boldText}:</strong> {normalText}
    </li>
  );
})}
</ul><br/> */}

{/* {interpretationSummary.map((summary, index) => {
  const [boldText, normalText] = summary.split(":");

  return (
    <div key={index} style={{ marginBottom: "5px" }}>
      <p style={{ fontSize: "16px" }}>
        <strong>{boldText}:</strong>
      </p>
      <p style={{ fontSize: "16px" }}>{normalText}</p>
    </div>
  );
})} */}
{/* {interpretationSummary.map((summary, index) => {
  const [boldText, normalText] = summary.split(":");
  const sentences = normalText.split("\n").filter(sentence => sentence.trim() !== ""); // Split by \n and remove empty strings

  return (
    <div className='result-group' key={index} style={{ marginBottom: "5px" }}>
      <h5>
        <strong>{boldText}:</strong>
      </h5>
      {sentences.map((sentence, i) => (
        <h5 key={i}>
          {sentence.trim()}
        </h5>
      ))}
    </div>
  );
})} */}


{interpretationSummary.map((summary, index) => {
  const splitText = summary.split(":");
  const boldText = splitText[0];
  const normalText = splitText.length > 1 ? splitText[1] : summary;

  // Split by \n and filter empty strings
  const sentences = normalText.split("\n").filter(sentence => sentence.trim() !== "");
  
  // Separate first sentence from the rest
  const firstSentence = sentences[0] || "";
  const remainingSentences = sentences.slice(1);

  return (
    <div className='result-group' key={index} style={{ marginBottom: "5px" }}>
      <h5 style={{ fontSize: "16px", display: "flex" }}>
        <strong style={{ marginRight: "4px" }}>{boldText}:</strong>
        <span>{firstSentence.trim()}</span>
      </h5>
      {remainingSentences.map((sentence, i) => (
        <h5 
          key={i} 
          style={{ 
            fontSize: "16px", 
            marginBottom: "2px",
            // marginLeft: boldText.length  // Indent aligned with text after bold
          }}
        >
          {sentence.trim()}
        </h5>
      ))}
    </div>
  );
})}



<div className='result-group mt-4'>
                <h2 style={{marginBottom: '10px'}}>Result</h2>
                <h5 style={{marginBottom: '15px'}}>{scoreMessageText}</h5>
                <h2 style={{marginBottom: '10px'}}>Score Interpretation</h2>
                <h5 className='result'>{selectedInterpretation}</h5>

                {assessmentInterpretations[assessmentOutcome.assessment_name]?.progressBarSettings && (
                    <ProgressBar
                        score={adjustedScore}
                        thresholds={assessmentInterpretations[assessmentOutcome.assessment_name].progressBarSettings.thresholds}
                        labels={assessmentInterpretations[assessmentOutcome.assessment_name].progressBarSettings.labels}
                        colors={assessmentInterpretations[assessmentOutcome.assessment_name].progressBarSettings.colors}
                    />
                )}
                </div>
            </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewResponses; 